import axios from 'axios';
import apiConfig from '../api.config';

export default function getGuestlinkOptions({ hotelId }) {
  const {
    host,
    URIs: { guestlinkOptions },
  } = apiConfig;

  const uri = `${host}${guestlinkOptions.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
